import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateAgencyPayment } from "common/services/payments.service";
import { toast } from "react-toastify";
import { extractFieldErrors } from "common/lib/fieldErrors";
import PaymentForm from "pages/Payments/PaymentForm";

const UpdatePayment: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<any>([]);
  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      projectOrFund: selectedRecord?.projectOrFund,
      staffId: selectedRecord?.staffId,
      isSalaryAligned: selectedRecord?.isSalaryAligned,
      amountPerMonth: selectedRecord?.amountPerMonth,
      startDate: selectedRecord?.startDate,
      endDate: selectedRecord?.endDate,
      paymentIdentifier: selectedRecord?.paymentIdentifier,
      dataProvidedBy: selectedRecord?.dataProvidedBy,
      positionTitle: selectedRecord?.positionTitle,
      individual: {
        value: selectedRecord?.individual?.id,
        label: selectedRecord?.individual?.fullName,
      },
      mda: {
        value: selectedRecord?.mda?.id,
        label: selectedRecord?.mda?.name,
      },
      agency: {
        value: selectedRecord?.agency?.id,
        label: selectedRecord?.agency?.name,
      },
      positionType: {
        value: selectedRecord?.positionType?.id,
        label: selectedRecord?.positionType?.name,
      },
      paymentCategory: {
        value: selectedRecord?.paymentCategory?.id,
        label: selectedRecord?.paymentCategory?.name,
      },
      region: {
        value: selectedRecord?.mda?.region?.id,
        label: selectedRecord?.mda?.region?.name,
      },
      thematicArea: {
        value: selectedRecord?.thematicArea?.id,
        label: selectedRecord?.thematicArea?.name,
      },
      sector: {
        value: selectedRecord?.sector?.id,
        label: selectedRecord?.sector?.name,
      },
    },
    validationSchema: Yup.object({
      projectOrFund: Yup.string().required("Please enter project or fund"),
      staffId: Yup.string().nullable(),
      amountPerMonth: Yup.number().required("Please enter amount per month"),
      startDate: Yup.string().required("Please enter start date"),
      endDate: Yup.string().required("Please enter end date"),
      // paymentIdentifier: Yup.string().required(
      //   "Please enter payment identifier"
      // ),
      dataProvidedBy: Yup.string().nullable(),
      positionTitle: Yup.string().required("Please enter position title"),
      individual: Yup.object().shape({
        value: Yup.number().required("Please select individual"),
      }),
      mda: Yup.object().shape({
        value: Yup.number().required("Please select MDA"),
      }),
      agency: Yup.object().shape({
        value: Yup.number().required("Please select agency"),
      }),
      positionType: Yup.object().shape({
        value: Yup.number().nullable(),
      }),
      paymentCategory: Yup.object().shape({
        value: Yup.number().nullable(),
      }),
      thematicArea: Yup.object().shape({
        value: Yup.number().nullable(),
      }),
      sector: Yup.object().shape({
        value: Yup.number().nullable(),
      }),
    }),
    onSubmit: async (values: any) => {
      const data = {
        id: selectedRecord?.id,
        data: {
          individual: values.individual?.value || null,
          mda: values.mda?.value || null,
          agency: values.agency?.value || null,
          positionType: values.positionType?.value || null,
          paymentCategory: values.paymentCategory?.value || null,
          projectOrFund: values.projectOrFund,
          staffId: values.staffId,
          isSalaryAligned: values.isSalaryAligned,
          amountPerMonth: values.amountPerMonth,
          startDate: values.startDate || null,
          endDate: values.endDate || null,
          // paymentIdentifier: values.paymentIdentifier,
          dataProvidedBy: values.dataProvidedBy,
          positionTitle: values.positionTitle,
          thematicArea: values.thematicArea?.value || null,
          sector: values.sector?.value || null,
        },
      };

      setLoading(true);
      try {
        await updateAgencyPayment(selectedRecord?.id, data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Payment updated successfully", {});
      } catch (e: any) {
        const errors = extractFieldErrors(e?.response);
        setFieldErrors(errors);
        toast.error("Payment update failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="xl"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Payment
      </ModalHeader>

      <PaymentForm
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
        fieldErrors={fieldErrors}
      />
    </Modal>
  );
};

export default UpdatePayment;
